/**
 * Splits an array of data into an array of smaller arrays "chunks".
 *
 * @param data
 * @param chunkSize Defaults to 50
 * @returns
 */
export function chunk<T>(data: T[], chunkSize = 50): T[][] {
    const chunks = data.reduce<T[][]>((prev, curr, i) => {
        // Gets the index
        const ch = Math.floor(i / chunkSize);
        prev[ch] = [...(prev[ch] || []), curr];
        return prev;
    }, []);
    return chunks;
}
